import { Component, OnInit } from '@angular/core';
import { LazyImgDirective } from '../shared/directives/lazy-img-directive.directive';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    imports: [LazyImgDirective, RouterLink, RouterLinkActive, RouterOutlet],
    standalone: true
})
export class AdminComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

}
